import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { TableHead, Paper, Box, TableContainer } from "@mui/material";
import deleteIcon from "../../images/dustbin.png";
import { addCat, removeCat } from "./categorySlice";
import { toast } from "react-toastify";
import Repo from "../../Repository/Repo";

export default function CategoriesList({ onClose }) {
  const dispatch = useDispatch();
  const companyCode = localStorage.getItem("companyCode");
  const categories = useSelector((state) => state.daybookCat.categories);

  const handleDelete = async (title, index) => {
    try {
      dispatch(removeCat({ index: index }));
      onClose();
      let { data } = await Repo.category({
        request: {
          method: "deleteDaybookCategory",
          data: {
            company_code: companyCode,
            category: title,
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        toast.configure();
        toast.success("Delete Successfully");
      } else {
        toast.configure();
        toast.error("Category Not Delete");
        dispatch(addCat(title));
      }
    } catch (err) {
      console.log(err);
      toast.configure();
      toast.error("Error");
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <Stack justifyContent="center">
          <Typography variant="h5" sx={{ mb: 2, color: "#4EAF51" }}>
            Categories List
          </Typography>
        </Stack>

        <TableContainer component={Paper}>
          {categories.length == 0 && (
            <Stack justifyContent="center">
              <Typography sx={{ color: "#4EAF51" }}>No Categories</Typography>
            </Stack>
          )}
          {categories.length != 0 && (
            <Table sx={{ minWidth: 550 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Remove</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categories.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell width="60px" component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item}
                    </TableCell>
                    <TableCell
                      align="center"
                      width="50px"
                      component="th"
                      scope="row"
                    >
                      <img
                        style={{ cursor: "pointer" }}
                        height="25px"
                        width="25px"
                        src={deleteIcon}
                        alt="delete"
                        onClick={() => handleDelete(item, index)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}
